<!--
 * @Descripttion: 登录页面组件(密码/短信验证码双模式 + 算式验证码)
 * @Author: cmall
 * @Date: 2026-08-13
-->
<template>
  <div class="login">
    <div>
      <el-card class="box-card" shadow="hover">
        <router-link class="login-logo-link" to="/">
          <img class="login-logo" src="../assets/imgs/clogo.png" alt />
        </router-link>
        <div class="clearfix">
          <span>Login</span>
        </div>
        <div class="item">
          <!-- 登录方式切换 -->
          <el-radio-group
            v-model="loginMode"
            size="small"
            style="margin-bottom:15px;"
          >
            <el-radio-button label="password">Password</el-radio-button>
            <el-radio-button label="otp">OTP Login</el-radio-button>
          </el-radio-group>

          <!-- 密码登录 -->
          <el-form
            v-if="loginMode === 'password'"
            :model="form"
            status-icon
            :rules="rules"
            ref="form"
          >
            <el-form-item prop="user_name">
              <el-input
                v-model="form.user_name"
                placeholder="Username or Phone"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="form.password"
                placeholder="Password"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha_value">
              <div class="math-captcha">
                <span
                  class="math-captcha-text"
                  title="Click to refresh"
                  @click="refreshCaptcha"
                  >{{ captcha.expression || 'Loading...' }}</span
                >
                <el-input
                  v-model="form.captcha_value"
                  placeholder="Answer"
                ></el-input>
              </div>
            </el-form-item>
          </el-form>

          <!-- 短信验证码登录 -->
          <el-form
            v-else
            :model="otpForm"
            status-icon
            :rules="otpRules"
            ref="otpForm"
          >
            <el-form-item prop="phone">
              <el-input
                v-model="otpForm.phone"
                placeholder="Phone Number"
              ></el-input>
            </el-form-item>
            <el-form-item prop="captcha_value">
              <div class="math-captcha">
                <span
                  class="math-captcha-text"
                  title="Click to refresh"
                  @click="refreshCaptcha"
                  >{{ captcha.expression || 'Loading...' }}</span
                >
                <el-input
                  v-model="otpForm.captcha_value"
                  placeholder="Answer"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                v-model="otpForm.code"
                maxlength="6"
                placeholder="SMS Verification Code"
              >
                <template slot="append">
                  <a href="javascript:;" class="sms-send" @click="sendCode">{{
                    countdown > 0 ? countdown + 's' : 'Send Code'
                  }}</a>
                </template>
              </el-input>
            </el-form-item>
          </el-form>

          <div style="margin-top:15px">
            <a
              href="javascript:;"
              class="btn-gradient desert block"
              @click="login"
              >Login</a
            >
          </div>
          <el-link
            type="primary"
            href="/#/register"
            style="float:right;margin-bottom:10px;"
            >Don't have an account? Please register first ></el-link
          >
        </div>
        <div class="line"></div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Login',
  data() {
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      }
      callback()
    }
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your phone number'))
      } else if (value.length < 6 || value.length > 15) {
        callback(new Error('Please enter a valid phone number'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (value.length !== 6) {
        callback(new Error('The verification code should be 6 digits'))
      }
      callback()
    }
    var validateCaptcha = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the math captcha answer'))
      }
      callback()
    }
    return {
      loginMode: 'password',
      captcha: {
        captcha_id: '',
        expression: ''
      },
      form: {
        user_name: '',
        password: '',
        captcha_value: ''
      },
      otpForm: {
        phone: '',
        code: '',
        captcha_value: ''
      },
      countdown: 0,
      rules: {
        user_name: [{ validator: validateUser, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        captcha_value: [{ validator: validateCaptcha, trigger: 'blur' }]
      },
      otpRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }],
        captcha_value: [{ validator: validateCaptcha, trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions(['setUser']),
    // 刷新算式验证码
    refreshCaptcha() {
      userAPI
        .getMathCaptcha()
        .then(res => {
          if (res.status === 200) {
            this.captcha.captcha_id = res.data.captcha_id
            this.captcha.expression = res.data.expression
          }
        })
        .catch(() => {
          this.captcha.expression = 'Refresh failed'
        })
    },
    // 发送短信验证码(需先通过算式验证码)
    sendCode() {
      if (this.countdown > 0) {
        return
      }
      if (this.otpForm.phone === '') {
        this.notifyError('Please enter your phone number')
        return
      }
      if (this.otpForm.captcha_value === '') {
        this.notifyError('Please enter the math captcha answer')
        return
      }
      userAPI
        .sendSMSCode({
          phone: this.otpForm.phone,
          captcha_id: this.captcha.captcha_id,
          captcha_value: this.otpForm.captcha_value
        })
        .then(res => {
          if (res.status === 200) {
            // 发送成功后才启动倒计时
            this.startCountdown()
            this.notifySucceed('SMS code sent, please check your phone')
          } else {
            this.notifyError('Failed to send code', res.msg)
          }
          // 算式验证码一次性,无论成败都清空并刷新
          this.otpForm.captcha_value = ''
          this.refreshCaptcha()
        })
        .catch(error => {
          this.otpForm.captcha_value = ''
          this.refreshCaptcha()
          this.notifyError('Failed to send code', error)
        })
    },
    // 60秒发送倒计时
    startCountdown() {
      var self = this
      self.countdown = 60
      var clock = window.setInterval(() => {
        self.countdown--
        if (self.countdown <= 0) {
          window.clearInterval(clock)
          self.countdown = 0
        }
      }, 1000)
    },
    // 登录(按当前模式分发)
    login() {
      if (this.loginMode === 'password') {
        this.passwordLogin()
      } else {
        this.otpLogin()
      }
    },
    // 密码登录
    passwordLogin() {
      var self = this
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .postLogin({
            user_name: self.form.user_name,
            password: self.form.password,
            captcha_id: self.captcha.captcha_id,
            captcha_value: self.form.captcha_value
          })
          .then(res => {
            self.handleLoginSuccess(res)
            self.form.captcha_value = ''
            self.refreshCaptcha()
          })
          .catch(error => {
            self.form.captcha_value = ''
            self.refreshCaptcha()
            self.notifyError('Login failed', error)
          })
      })
    },
    // 短信验证码登录/注册
    otpLogin() {
      var self = this
      this.$refs.otpForm.validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .smsLogin({
            phone: self.otpForm.phone,
            code: self.otpForm.code
          })
          .then(res => {
            self.handleLoginSuccess(res)
          })
          .catch(error => {
            self.notifyError('Login failed', error)
          })
      })
    },
    // 登录成功统一处理
    handleLoginSuccess(res) {
      if (res.status === 404) {
        this.notifyError('Verification failed', res.msg)
      } else if (res.status === 200) {
        // 登录信息存到本地
        let user = JSON.stringify(res.data.user)
        localStorage.setItem('user', user)
        localStorage.setItem('token', res.data.token)
        // 登录信息存到vuex
        this.setUser(res.data.user)
        // 弹出通知框提示登录成功信息
        this.notifySucceed('Login successful')
        this.$router.push({
          name: 'Home'
        })
      } else {
        this.notifyError('Login failed', res.msg)
      }
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
  margin-bottom: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 300px;
  border-radius: 10px;
}
.login-logo-link {
  display: flex;
  justify-content: center;
}
.login-logo {
  width: 120px;
  height: auto;
}
.box-card .line {
  height: 30px;
  width: 300px;
  margin: 0 auto;
  border-bottom: 1px solid #c0c0c0;
}
/*算式验证码*/
.math-captcha {
  display: flex;
  width: 100%;
}
.math-captcha-text {
  flex: 0 0 90px;
  height: 40px;
  line-height: 40px;
  background-color: #FAF5EF;
  border: 1px solid #dcdfe6;
  border-right: none;
  border-radius: 4px 0 0 4px;
  color: #409eff;
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}
.sms-send {
  cursor: pointer;
  color: #409eff;
}
</style>
